import flowStore from 'src/stores/flowStore';
import { firePageCompletedAction } from 'src/dispatcher';
import PageView from './view';

class PageViewController {
  constructor() {
    this.view = new PageView();
    this.view.addCompletedListener(this.onPageCompleted.bind(this));
  }

  destroy() {
    this.view.removeCompletedListener(this.onPageCompleted);
  }

  onStateChange() {
    this.view.render(flowStore.getActiveNode(), flowStore.getFlowLocales());
  }

  onPageCompleted() {
    firePageCompletedAction();
  }
}

export default PageViewController;
